var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfessionalGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28160_14929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.67684 25.9154C4.67684 23.6443 5.09566 21.4396 5.9202 19.3496L2.37727 15.8066C0.817266 18.9305 0 22.3851 0 25.9154C0 38.4006 10.1575 48.558 22.6427 48.558C23.7605 48.558 24.8766 48.4744 25.9762 48.3125V43.5702C24.882 43.7765 23.7674 43.8811 22.6427 43.8811C12.7364 43.8811 4.67684 35.8217 4.67684 25.9154Z",
    fill: "#2B71F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8512 15.5411L13.1799 12.1022L7.87264 6.79492L6.54385 10.2338L3.10498 11.5626L8.41228 16.8699L11.8512 15.5411Z",
    fill: "#2B71F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6426 19.6582C21.4462 19.6582 20.3275 19.9962 19.3761 20.5809L23.6769 24.8817L21.191 27.3676L17.0116 23.1882C16.6104 24.0131 16.3848 24.9387 16.3848 25.916C16.3848 29.3665 19.192 32.1737 22.6425 32.1737C26.093 32.1737 28.9003 29.3665 28.9003 25.916C28.9004 22.4654 26.0932 19.6582 22.6426 19.6582Z",
    fill: "#2B71F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5036 52.4069H42.9879V48.8363L29.4917 44.5156V56.7253H59.9998V44.5156L46.5036 48.8363V52.4069Z",
    fill: "#4FB5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7369 37.1663V31.0545L51.7633 30.5692C47.107 28.2478 42.3849 28.2478 37.7285 30.5692L36.7549 31.0545V37.1663H29.4917V40.8238L44.7458 45.7071L60.0001 40.8238V37.1663H52.7369ZM49.2213 37.1663H40.2706V33.2723C43.2733 32.0353 46.2186 32.0353 49.2213 33.2723V37.1663Z",
    fill: "#4FB5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6427 7.95016C32.5105 7.95016 40.5447 15.9473 40.6071 25.8006C41.9808 25.4774 43.3634 25.313 44.7459 25.313C44.9231 25.313 45.1004 25.3158 45.2776 25.3212C44.961 13.1098 34.9291 3.27344 22.6427 3.27344C18.7938 3.27344 15.1668 4.23988 11.9897 5.94098L15.4872 9.43844C17.6811 8.48195 20.1008 7.95016 22.6427 7.95016Z",
    fill: "#2B71F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2394 33.6502V31.054V28.8784L35.1864 27.9078L36.16 27.4224C36.4565 27.2746 36.7539 27.1362 37.0521 27.0039C37.079 26.6444 37.093 26.2814 37.093 25.9151C37.093 17.9472 30.6106 11.4648 22.6427 11.4648C20.5629 11.4648 18.5679 11.8954 16.7004 12.7442L15.2622 16.4659L16.8474 18.0511C18.4701 16.8521 20.4747 16.1416 22.6427 16.1416C28.0318 16.1416 32.4161 20.5259 32.4161 25.915C32.4161 29.0602 30.9213 31.8611 28.6063 33.6501H29.4918H33.2394V33.6502Z",
    fill: "#2B71F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6425 35.6896C17.2536 35.6896 12.8692 31.3053 12.8692 25.9163C12.8692 23.9631 13.4474 22.1434 14.4384 20.6152L12.7763 18.9531L9.3373 20.2819C8.57816 22.0657 8.19238 23.9598 8.19238 25.9163C8.19238 33.8841 14.6747 40.3664 22.6427 40.3664C23.7897 40.3664 24.9057 40.2312 25.9762 39.9774V37.1669V35.1036C24.9352 35.4824 23.8127 35.6897 22.6425 35.6896Z",
    fill: "#2B71F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28160_14929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalGoals);
export default __webpack_public_path__ + "static/media/professional_goals.eaec019de758c7ec44eff3ea9f5f4707.svg";
export { ForwardRef as ReactComponent };